var _ellipse, _ellipse2, _path, _path2, _path3, _g, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg11DeskLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1048,
    viewBox: "0 0 1440 1048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 503.443,
    cy: 505.62,
    rx: 19.823,
    ry: 12.114,
    transform: "rotate(8.79989 503.443 505.62)",
    fill: "#333846"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 503.443,
    cy: 504.519,
    rx: 19.823,
    ry: 12.114,
    transform: "rotate(8.79989 503.443 504.519)",
    fill: "url(#paint0_radial_1989_6014)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M522.786 507.513C522.292 510.7 519.724 513.298 515.888 514.897C512.057 516.495 507 517.075 501.628 516.243C496.256 515.412 491.611 513.329 488.442 510.649C485.269 507.964 483.607 504.712 484.1 501.524C484.594 498.337 487.162 495.739 490.998 494.14C494.829 492.543 499.886 491.963 505.258 492.794C510.63 493.626 515.275 495.708 518.444 498.389C521.617 501.073 523.279 504.326 522.786 507.513Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M497.988 416.165C497.988 414.502 499.336 413.154 500.999 413.154H503.256C504.919 413.154 506.266 414.502 506.266 416.165V502.709C506.266 504.371 504.919 505.719 503.256 505.719H500.999C499.336 505.719 497.988 504.371 497.988 502.709V416.165Z",
    fill: "url(#paint1_linear_1989_6014)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M497.988 416.165C497.988 414.502 499.336 413.154 500.999 413.154H503.256C504.919 413.154 506.266 414.502 506.266 416.165V502.709C506.266 504.371 504.919 505.719 503.256 505.719H500.999C499.336 505.719 497.988 504.371 497.988 502.709V416.165Z",
    fill: "#171B23"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_1989_6014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.266 504.59C506.266 505.629 504.413 506.472 502.127 506.472C499.841 506.472 497.988 505.629 497.988 504.59C497.988 503.551 499.841 502.709 502.127 502.709C504.413 502.709 506.266 503.551 506.266 504.59Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_1989_6014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.266 417.293C506.266 418.332 504.413 419.175 502.127 419.175C499.841 419.175 497.988 418.332 497.988 417.293C497.988 416.254 499.841 415.412 502.127 415.412C504.413 415.412 506.266 416.254 506.266 417.293Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M497.243 413.445C497.243 411.197 499.066 409.374 501.314 409.374H504.367C506.615 409.374 508.438 411.197 508.438 413.445C508.438 415.693 506.615 417.516 504.367 417.516H501.314C499.066 417.516 497.243 415.693 497.243 413.445Z",
    fill: "#202530"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M503.059 413.445C503.059 415.693 501.757 417.516 500.151 417.516C498.545 417.516 497.243 415.693 497.243 413.445C497.243 411.197 498.545 409.374 500.151 409.374C501.757 409.374 503.059 411.197 503.059 413.445Z",
    fill: "#383F4E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M502.04 413.445C502.04 415.693 500.738 417.516 499.132 417.516C497.526 417.516 496.225 415.693 496.225 413.445C496.225 411.197 497.526 409.374 499.132 409.374C500.738 409.374 502.04 411.197 502.04 413.445Z",
    fill: "#495061"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.576 415.886C501.001 415.291 501.287 414.43 501.287 413.445C501.287 412.459 501.001 411.599 500.576 411.004C500.15 410.407 499.629 410.127 499.132 410.127C498.635 410.127 498.115 410.407 497.689 411.004C497.264 411.599 496.977 412.459 496.977 413.445C496.977 414.43 497.264 415.291 497.689 415.886C498.115 416.482 498.635 416.763 499.132 416.763C499.629 416.763 500.15 416.482 500.576 415.886ZM499.132 417.516C500.738 417.516 502.04 415.693 502.04 413.445C502.04 411.197 500.738 409.374 499.132 409.374C497.526 409.374 496.225 411.197 496.225 413.445C496.225 415.693 497.526 417.516 499.132 417.516Z",
    fill: "#202736"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.16 409.374C503.16 409.374 503.167 409.374 503.271 409.374C503.943 409.374 504.577 409.726 504.956 410.482C505.34 411.25 505.572 412.298 505.572 413.445C505.572 414.592 505.34 415.639 504.956 416.407C504.577 417.164 504.366 417.516 503.694 417.516C503.591 417.516 503.16 417.516 503.16 417.516C503.16 417.412 503.244 417.327 503.348 417.327C503.801 417.327 504.261 416.956 504.619 416.239C504.972 415.534 505.196 414.546 505.196 413.445C505.196 412.344 504.972 411.356 504.619 410.65C504.261 409.934 503.801 409.562 503.348 409.562C503.244 409.562 503.16 409.478 503.16 409.374Z",
    fill: "#383F4E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M543.923 441.774L504.24 417.835C502.5 416.809 502.879 414.189 504.839 413.7L508.288 412.837C509.406 412.558 510.59 412.717 511.595 413.282L551.848 436.109C553.412 436.988 553.375 439.252 551.783 440.08L548.3 441.891C546.919 442.609 545.265 442.565 543.923 441.774Z",
    fill: "url(#paint2_linear_1989_6014)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M509.678 421.241C509.784 421.062 510.015 421.003 510.194 421.108L543.233 441.217C543.412 441.322 543.471 441.553 543.366 441.732C543.26 441.911 543.029 441.97 542.85 441.864L509.811 421.756C509.632 421.65 509.573 421.419 509.678 421.241Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1989_6014",
    x: 493.988,
    y: 498.709,
    width: 16.2783,
    height: 11.7627,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1989_6014"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1989_6014",
    x: 493.988,
    y: 411.412,
    width: 16.2783,
    height: 11.7627,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1989_6014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1989_6014",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(503.443 504.519) rotate(90) scale(12.114 19.823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#626A80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1989_6014",
    x1: 506.266,
    y1: 459.06,
    x2: 497.988,
    y2: 459.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523914,
    stopColor: "#62697C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636A7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1989_6014",
    x1: 538.25,
    y1: 427.453,
    x2: 533.359,
    y2: 435.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491362,
    stopColor: "#697084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20232A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg11DeskLight);
export default __webpack_public_path__ + "static/media/11DeskLight.13229b147d7fb32b6a07e886d3ee1979.svg";
export { ForwardRef as ReactComponent };